export const pageTitleTranslationId = {
  SEARCH: 'search',
  HOME: 'home',
  MATCH: 'match',
  HISTORY: 'history',
}
